// utils
import { lazy, Suspense, useEffect, useRef } from 'react';

import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import WidgetsLoader from '@components/WidgetsLoader';
import { saveRedirectPath } from '@utils/loginRedirect';

// hooks
import PageNotFound from '@pages/PageNotFound';
import ForgotPassword from '@pages/ForgotPassword';
import ResetPassword from '@pages/ResetPassword';
import AddPassword from '@pages/AddPassword';
import WebsiteTutorial from '@pages/WebsiteTutorial';
import ContactUsPublic from '@pages/ContactUsPublic';
import PrivacyPolicyPublic from '@pages/PrivacyPolicyPublic';

// pages
const LoginPage = lazy(() => import('@pages/Login'));
const ActivateUser = lazy(() => import('@pages/ActivateUser'));
const NotificationConfirmed = lazy(() => import('@pages/NotificationConfirmed'));

// Signed-out visitor on a protected URL (an email deep link, a bookmark). Remember where
// they were headed, then send them to sign in - authContext takes them back afterwards.
const RedirectToLogin = () => {
  const location = useLocation();
  saveRedirectPath(`${location.pathname}${location.search}`);
  return <Navigate to="/login" replace />;
};

const AuthLayout = () => {
  const appRef = useRef(null);

  useEffect(() => {
    if (appRef.current) {
      appRef.current.scrollTo(0, 0);
    }
  }, []);

  return (
      <Suspense fallback={<WidgetsLoader />}>
        <Routes>
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/add-password" element={<AddPassword />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/password-reset/:uid/:token/" element={<ResetPassword />} />
          <Route path="/app-tutorial" element={<WebsiteTutorial />} />
          <Route path="/activate-user" element={<ActivateUser />} />
          <Route path="/notification-confirmed" element={<NotificationConfirmed />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPublic />} />
          <Route path="/contact-us" element={<ContactUsPublic />} />
          <Route path="/404" element={<PageNotFound />} />
          <Route path="*" element={<RedirectToLogin />} />
        </Routes>
      </Suspense>
  );
};

export default AuthLayout;
